import React from 'react'

import { capitalizeString } from '../../../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'

import { EditDeleteDropdown } from '../../../EditDeleteDropdown'

export default function Role({
  canManageTeam,
  role,
  handleShowCreate,
  handleShowDelete,
  hasPermission,
  nameMatchesReservedAccountOwner,
  nameMatchesHiddenOrganizationRole,
}) {
  const roleHeadingId = `role-heading-${role?.id ?? 'unknown'}`

  return (
    <Stack
      direction="horizontal"
      as="li"
      className="list-item split-row"
      aria-labelledby={roleHeadingId}
    >
      <h2 id={roleHeadingId} className="heading heading-sm lh-lg m-0">
        {capitalizeString(role?.name)}
      </h2>
      {/* account owners and admins can edit/delete roles */}
      {canManageTeam && (
        <>
          {!nameMatchesReservedAccountOwner(role?.name) &&
            !nameMatchesHiddenOrganizationRole(role?.name) && (
              <EditDeleteDropdown
                onClick={(e) => handleShowCreate(e, role)}
                handleShow={() => handleShowDelete(role?.id)}
                hasPermission={hasPermission}
              />
            )}
        </>
      )}
    </Stack>
  )
}
